import Player from 'video.js/dist/types/player';

export const setupProgressSpacing = (player: Player) => {
  const progressControl = player.el().querySelector('.vjs-progress-control');
  if (!progressControl) return;

  const progressHolder = progressControl.querySelector('.vjs-progress-holder');
  if (!progressHolder) return;

  const spacingDiv = document.createElement('div');
  spacingDiv.className = 'vjs-progress-spacing';

  progressHolder.appendChild(spacingDiv);

  let animationFrameId: number | null = null;
  let isDragging = false;

  const updateSpacing = () => {
    const playProgressElement = progressControl.querySelector('.vjs-play-progress') as HTMLElement;

    if (!progressHolder || !playProgressElement) return;

    const holderWidth = (progressHolder as HTMLElement).offsetWidth;
    const progressWidth = parseFloat(playProgressElement.style.width || '0');

    const remainingPercentage = 100 - progressWidth;
    const spacingWidth = (holderWidth * remainingPercentage) / 100 - 4 - 2 - 3;

    spacingDiv.style.width = `${spacingWidth}px`;
  };

  const continuousUpdate = () => {
    if (!player.paused() || isDragging) {
      updateSpacing();
      animationFrameId = requestAnimationFrame(continuousUpdate);
    }
  };

  const handleDragStart = () => {
    isDragging = true;
    if (animationFrameId === null) {
      continuousUpdate();
    }
  };

  const handleDragEnd = () => {
    isDragging = false;
    updateSpacing();
  };

  progressHolder.addEventListener('mousedown', handleDragStart);
  document.addEventListener('mouseup', handleDragEnd);
  progressHolder.addEventListener('touchstart', handleDragStart);
  document.addEventListener('touchend', handleDragEnd);

  player.on('play', () => {
    continuousUpdate();
  });

  player.on('pause', () => {
    if (animationFrameId !== null && !isDragging) {
      cancelAnimationFrame(animationFrameId);
      animationFrameId = null;
    }
    updateSpacing();
  });

  player.on('ended', () => {
    if (animationFrameId !== null) {
      cancelAnimationFrame(animationFrameId);
      animationFrameId = null;
    }
    updateSpacing();
  });

  player.on('seeked', updateSpacing);
  player.on('loadedmetadata', updateSpacing);

  setTimeout(updateSpacing, 100);
};
